
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Card,
    CardHeader,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Table,
    UncontrolledDropdown,
} from "reactstrap";
import ContentService from "../../../services/xgContentService";
import NextStepsService from "../../../services/nextStepsService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import MeetingReportService from "../../../services/meetingReportService";
import _ from "lodash";
import visibleForRoles from "../../../util/visibleForRoles";
import routeVisibleForRole from "../../../util/routeVisibleForRole";

class NextStepsCompleteList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            completeList:[],
            alert: null
        };
        this.delete = this.delete.bind(this);
        this.notify = this.notify.bind(this);
        this.filterTodosByUserId = this.filterTodosByUserId.bind(this);
    }

    componentDidMount() {
        this.populateNextSteps();

    }

    populateNextSteps(){
        NextStepsService.list().then((response) => {
            console.log(response);
            this.setState({completeList: response, list:response});
            if(routeVisibleForRole(["ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3"])){
                let currentUserId = localStorage.getItem('userId')
                let filteredList = this.filterTodosByUserId(this.state.completeList, localStorage.getItem('userId'))
                this.setState({list: filteredList})
            }

        });
    }

     filterTodosByUserId = (data, userId) => {
        return _.filter(data, obj => obj?.assignedUser?.uniqueId === userId);
    };

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    };

    markClosed = (uniqueId) => {
        NextStepsService.markClosed(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                "Task Closed Successfully!"
            );
            this.populateNextSteps();
        });

        NextStepsService.markClosed(uniqueId)
    }

    confirmDeleteAlert = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={() => this.delete(uniqueId)}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };

    delete(uniqueId) {
        this.setState({alert: null})
        NextStepsService.delete(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            //TODO: TO be fixed with redux implementation
            //   this.props.history.push("/admin/dashboard");
            // ContentService.list().then((response) => {
            //   console.log(response);
            //   this.setState({list: response});
            // });
        });
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    render() {
        let obj = this;
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                {this.state.alert}
                <Container className="mt--6" fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardHeader className="border-0">
                                    <Row className="align-items-center">
                                        <div className="col">
                                            <h3 className="mb-0">Next Steps</h3>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <Table className="align-items-center table-flush" responsive>
                                    <thead className="thead-light">
                                    <tr>
                                        <th className="sort" data-sort="name" scope="col">
                                            #
                                        </th>
                                        <th className="sort" data-sort="budget" scope="col">
                                            Date Created
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Todo
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            By When
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            Status
                                        </th>
                                        <th className="sort" data-sort="status" scope="col">
                                            User Assigned
                                        </th>
                                        <th scope="col"/>
                                    </tr>
                                    </thead>
                                    <tbody className="list">
                                    {obj.state?.list?.map(function (value, index) {
                                        return (
                                            <tr key={index}>
                                                <td className="budget">{index + 1}</td>
                                                <td className="budget">{value?.dateCreated}</td>
                                                <td className="budget">{value?.todo}</td>
                                                <td className="budget">{value?.byWhen}</td>
                                                <td className="budget">{value.nextStepsStatus}</td>
                                                <td className="budget">{value.assignedUser.fullName}</td>
                                                <td className="text-right">
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle
                                                            color=""
                                                            size="sm"
                                                            className="btn-icon-only text-light"
                                                        >
                                                            <i className="fas fa-ellipsis-v"/>
                                                        </DropdownToggle>
                                                        <DropdownMenu
                                                            className="dropdown-menu-arrow"
                                                            right container="body"
                                                        >
                                                            {/*<DropdownItem
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.props.history.push(
                                                                        `/admin/content/show/${value.uniqueId}`
                                                                    );
                                                                }}
                                                            >
                                                                Details
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.props.history.push(
                                                                        `/admin/content/edit/${value.uniqueId}`
                                                                    );
                                                                }}
                                                            >
                                                                Edit
                                                            </DropdownItem>*/}
                                                            <DropdownItem
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.confirmDeleteAlert(`${value.uniqueId}`);
                                                                }}
                                                            >
                                                                Delete
                                                            </DropdownItem>
                                                            <DropdownItem
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    obj.markClosed(`${value.uniqueId}`);
                                                                }}
                                                            >
                                                                Mark Closed
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </>
        );
    }
}

export default NextStepsCompleteList;
